const internalIp = require("internal-ip");

const findIp = async () => await internalIp.v4();

export default findIp;
